
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 3h4c1.093 0 2 .907 2 2v1h3V5h2v1h2c1.093 0 2 .907 2 2v16c0 1.093-.907 2-2 2H5c-1.093 0-2-.907-2-2V8c0-1.093.907-2 2-2h2V5h2v1h3V5c0-1.093.907-2 2-2zm0 2v1h4V5h-4zM5 8v16h2V9h2v15h14V9h2v15h2V8H5z"}})])
          )
        }
      }
    